// extracted by mini-css-extract-plugin
export default {"main":"Main_main__VxJ0O","divider":"Main_divider__olnup","column":"Main_column__oEylz","secondColumn":"Main_secondColumn__eSkJW","loader":"Main_loader__RNdOX"};